import React from "react";
import {
  ASSET,
  LIABILITY_M,
  EQUITY_M,
  EBITDA_M,
  LABA_BERSIH_M,
  PENDAPATAN_USAHA,
  DEVIDEN,
  PENYERTAAN_MODAL,
  CHART_DASHBOARD,
  CHART_DASHBOARD_ASSET
} from "../../constants/chart";
import FormFilterKontribusi from "./FormFilterKontribusi";
import BarOrPieChart from "./BarOrPieChart";
import BarStackOrPieChart from "./BarStackOrPieChart";
import TableLegendDashboard from "./TableLegendDashboard";
import TableLegendDashbardAsset from "./TableLegendDashbardAsset";


export default () => {
  return (

    <div className="card container py-3 border-0 h-100 d-flex justify-content-center align-items-center">
      <div className="col-md-10  mb-md-0 mb-2 ">
        <FormFilterKontribusi />
        <div className="row container py-3 " >
          <BarOrPieChart type={PENDAPATAN_USAHA} />
          <BarOrPieChart type={LABA_BERSIH_M} />
          <BarOrPieChart type={EBITDA_M} />
        </div>
        <div className="row container py-3" >
          <TableLegendDashboard type={CHART_DASHBOARD} />
        </div>
        <div className="row container py-3 " >
          <BarStackOrPieChart type={ASSET} />
          <BarOrPieChart type={LIABILITY_M} />
          <BarOrPieChart type={EQUITY_M} />
        </div>
        <div className="row container py-3" >
          <TableLegendDashbardAsset />
        </div>
      </div>
    </div>
  );
};
